module.exports = __webpack_public_path__ + "img/puzzled.a133f28.png";